import script from "./LoadingBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoadingBox.vue?vue&type=script&lang=ts&setup=true"

import "./LoadingBox.vue?vue&type=style&index=0&id=e9d0185a&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9d0185a"]])

export default __exports__